// Xử lý nút BACK CỨNG của Android cho app native (Capacitor).
// Web KHÔNG dùng file này. Trên web không có nút back cứng.
//
// Cơ chế: 1 stack "handler". Component nào đang mở lớp phủ (modal, luồng chat...) thì
// đăng ký 1 handler đóng lớp đó. Bấm back:
//   1) còn handler -> gọi handler trên cùng (đóng 1 lớp)
//   2) không còn, trang hiện tại mở ra từ 1 trang cha (VD chức năng vận hành mở từ màn Vận hành)
//      -> về trang cha; không có cha mà đang ở trang con -> về trang chủ
//   3) đang ở trang chủ -> bấm back lần 2 trong 2 giây để thoát app
import { Capacitor } from '@capacitor/core';

const handlers = []; // [{ fn }]
let inited = false;
let lastBackAt = 0;
let pageCtl = null; // { getPage, getParent, setPage, homePage, toast }

// Component gọi khi mở lớp phủ; trả về hàm gỡ (gọi khi đóng).
export function pushBackHandler(fn) {
  const entry = { fn };
  handlers.push(entry);
  return () => {
    const i = handlers.indexOf(entry);
    if (i >= 0) handlers.splice(i, 1);
  };
}

// App.jsx cấp cách đọc/đổi trang + hàm toast (nếu có).
export function setPageController(ctl) {
  pageCtl = ctl;
}

export async function initBackButton() {
  if (inited) return;
  if (!Capacitor?.isNativePlatform?.()) return;
  inited = true;
  const { App } = await import('@capacitor/app');
  App.addListener('backButton', async () => {
    // 1) Đóng lớp phủ trên cùng (modal / luồng chat / lightbox...).
    if (handlers.length) {
      const top = handlers[handlers.length - 1];
      try { top.fn(); } catch (e) { /* ignore */ }
      return;
    }
    // 2) Có trang cha -> về trang cha; không thì đang ở trang con -> về trang chủ.
    if (pageCtl && typeof pageCtl.getPage === 'function' && pageCtl.getPage() !== pageCtl.homePage) {
      const parent = typeof pageCtl.getParent === 'function' ? pageCtl.getParent() : '';
      pageCtl.setPage(parent || pageCtl.homePage);
      return;
    }
    // 3) Ở trang chủ -> bấm 2 lần trong 2s để thoát.
    const now = Date.now();
    if (now - lastBackAt < 2000) {
      App.exitApp();
    } else {
      lastBackAt = now;
      try { pageCtl && pageCtl.toast && pageCtl.toast('Bấm quay lại lần nữa để thoát'); } catch (e) { /* ignore */ }
    }
  });
}
